import React, {useEffect, useState, useContext} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Modal, ModalBody, ModalHeader, Button, ButtonToolbar, Row, Col, Spinner, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import axios from 'axios'
import renderDropZoneField from '@/shared/components/form/DropZone';
import {useDispatch, flashSuccess, flashError} from "@/shared/components/flash";
import {mapFormDataUploads, unpatchMedia, patchMediaURL, removeFields, isEmpty} from '@/shared/helpers'
import classnames from 'classnames';
import Slider from "@/shared/components/form/Slider"
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {getThemeByName, resetTheme, getTheme, deleteThemeMedia} from '@/services/program/programTheme'
import renderSelectOptionsField from '@/shared/components/form/SelectOptions';
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'
import { THEME_FONT_FAMILIES  } from './ThemeData';
import { ColorPicker } from 'material-ui-color';
import { inArray } from '@/shared/helpers';
import "./style.scss";

const MEDIA_FIELDS = ['small_logo', 'big_logo', 'hero_banner', 'slider_01', 'slider_02', 'slider_03']
const THEME_IMAGE = {
    'Default' : `${process.env.PUBLIC_URL}/img/theme/Original.png`,
    'Clear' : `${process.env.PUBLIC_URL}/img/theme/Original.png`,
    'Classic' : `${process.env.PUBLIC_URL}/img/theme/New.png`,
}
const THEME_OPTIONS = [
    { value: "Clear", label: "Clear" },
    { value: "Classic", label: "Classic" },
];

const toRgba = (color, alpha, fallback) => {
    if (!color || typeof color !== 'string') {
        return fallback;
    }

    let normalized = color.trim().replace('#', '');

    if (normalized.length === 3) {
        normalized = normalized.split('').map((char) => `${char}${char}`).join('');
    }

    if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
        return fallback;
    }

    const r = parseInt(normalized.slice(0, 2), 16);
    const g = parseInt(normalized.slice(2, 4), 16);
    const b = parseInt(normalized.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const getContrastColor = (color, light = '#ffffff', dark = '#0f172a') => {
    if (!color || typeof color !== 'string') {
        return light;
    }

    let normalized = color.trim().replace('#', '');

    if (normalized.length === 3) {
        normalized = normalized.split('').map((char) => `${char}${char}`).join('');
    }

    if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
        return light;
    }

    const r = parseInt(normalized.slice(0, 2), 16);
    const g = parseInt(normalized.slice(2, 4), 16);
    const b = parseInt(normalized.slice(4, 6), 16);
    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return brightness > 165 ? dark : light;
};

const ThemeMediaCard = ({
    name,
    title,
    description,
    required = false,
    currentTheme,
    src,
    showDelete = false,
    onDelete,
    previewClassName = '',
    cardClassName = '',
}) => (
    <div className={`manager-theme-settings__asset-card${cardClassName ? ` ${cardClassName}` : ''}`}>
        <div className="manager-theme-settings__asset-head">
            <div className="manager-theme-settings__asset-copy">
                <h4 className="manager-theme-settings__asset-title">{title}</h4>
                {description && <p className="manager-theme-settings__asset-description">{description}</p>}
            </div>
            {required && <span className="manager-theme-settings__asset-tag">Required</span>}
        </div>
        {currentTheme !== 'Default' && (
            <div className="manager-theme-settings__asset-upload">
                <Field
                    name={name}
                    component={renderDropZoneField}
                    multiple={false}
                    customHeight
                    uploadTitle={{ type: 'short', displayAlways: true }}
                />
            </div>
        )}
        <div className={`image-wrap manager-theme-settings__asset-preview${previewClassName ? ` ${previewClassName}` : ''}`}>
            <RenderImage
                src={src}
                showDelete={showDelete}
                name={name}
                dlcb={onDelete}
                label={title}
            />
        </div>
    </div>
);

const ThemeSettings = ({isOpen, toggle, program, theme, rtl}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [currentTheme, setCurrentTheme] = useState("Default");
    let [template, setTemplate] = useState({})
    const validate = values => {
      let errors = {}
      if( !values.name && !currentTheme )
      {
        errors.name = 'Select a theme'
      }
      if( !values.big_logo && !template.big_logo )
      {
        errors.big_logo = 'Big logo is required'
      }
      if( !values.small_logo && !template.small_logo )
      {
        errors.small_logo = 'Small logo is required'
      }
      if( !values.hero_banner && !template.hero_banner )
      {
        errors.hero_banner = 'hero banner is required'
      }
      if( isEmpty(values.slider_01) && isEmpty(template.slider_01) )
      {
        errors.slider_01 = 'Atleast one slider image is required'
      }
      if( !fontFamily )
      {
        errors.font_family = 'font_family is required'
      }
      // console.log(errors)
      // setError(errors)
      return errors
    }

    const isShowDeleteImage = (fieldName) => {
      if( currentTheme != 'Default' ) {
        if( template?.inherited?.fields && typeof template.inherited.fields === 'object')
        {
          if(inArray(fieldName, template.inherited.fields)) {
            return false
          }
        }
        return true;
      }
    }

    const deleteImage = (name) => {
      deleteThemeMedia(program.organization_id, program.id, template.id, name)
      .then( res => {
        setTemplate((prevState) => ({
          ...prevState,
          [name]: null,
        }));
      })
    }
    const onSubmitForm = async (values) => {
        values.button_corner = sliderValue;
        values.theme_color = selectedThemeColor;
        values.button_color = selectedColor;
        values.button_bg_color = selectedBGColor;
        values.font_family = fontFamily;
        values.name = currentTheme;
        setLoading(true)
        values = removeFields(values, ["created_at", "updated_at", "is_active"])
        values = unpatchMedia(values, MEDIA_FIELDS)
        let formData = mapFormDataUploads( values )
        let saveUrl = `/organization/${program.organization_id}/program/${program.id}/template`;
        if( template?.id && template.program_id == program.id )  { //Checks if the subprogram uses the parent's template as the default.
            formData.append('_method', 'PUT')
            saveUrl += `/${template.id}`
        }
        axios.post(saveUrl, formData, {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
        })
        .then( (res) => {
            // console.log(res)
            // toggle();
            if(res.status === 200)  {
                // setTemplate(res.data)
                getSetTheme(program)
                flashSuccess(dispatch, 'Program Template updated successfully');
                // if( !template?.id)  {
                //     window.location.reload();
                // }
                setLoading(false)
            }
        })
        .catch( error => {
            // console.log(error)
            // console.log(JSON.stringify(error.response.data.errors));
            flashError(dispatch, error.response.data.errors)
            // throw new Error(`API error:${e?.message}`);
            setLoading(false)
        })
    }

    // Tabs Panel
    const [currentActiveTab, setCurrentActiveTab] = useState('1');
    const togglePan = tab => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }

    // Slider
    const SliderConfig = [
        {
            value: 0,
            label: "Square",
        },
        {
            value: 20,
            label: "Rounded",
        },
    ];
    const [sliderValue, setSliderValue] = useState(0);
    const updateSliderRange = (e, data) => {
        if (typeof data === 'number' && sliderValue !== data) {
            template.button_corner = data;
            setTemplate(template);
            setSliderValue(data);
        }
    };

    // Theme Color
    const [selectedThemeColor, setSelectedThemeColor] = useState(null);
    const updateThemeColorHandler = (e, data) => {
        setSelectedThemeColor('#'+e.hex);
    };

    // Color
    const [selectedColor, setSelectedColor] = useState(null);
    const updateColorHandler = (e) => {
        console.log(e);
        setSelectedColor('#'+e.hex);
    };

    // BG Color
    const [selectedBGColor, setSelectedBGColor] = useState(null);
    const updateBGColorHandler = (e) => {
        console.log(e);
        setSelectedBGColor('#'+e.hex);
    };

    // Font Type
    const [fontFamily, setFontFamily] = useState(null);
    const fontFamilyHandler = (e, data) => {
        setStylePath("https://fonts.googleapis.com/css?family="+data+":100,300,400,500,700,900");
        setFontFamily(data);
    };

    const [ stylePath, setStylePath ] = useState("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");

    const onSelectTheme = (selectedOption) => {
        getThemeByName(program.organization_id, program.id, selectedOption.value)
            .then( theme => {
                setTemplate(theme ? theme : {})
            });
        
        setCurrentTheme(selectedOption.value);
    };

    const getSetTheme = (program) => {
      getTheme(program.organization_id, program.id)
        .then( theme => {
          setTemplate(theme ? theme : {})
        })
    }

    useEffect(() => {
        if(program && program?.id)
        {
          getSetTheme(program)
        }
    }, [program]);

    useEffect(() => {
        var head = document.head;
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = stylePath;
        head.appendChild(link);
        return () => { head.removeChild(link); }
    }, [stylePath]);

    useEffect(() => {
        if ( Object.keys(template).length > 0 ){
          setCurrentTheme(template.name);
          setSliderValue(parseInt(template.button_corner))
          setSelectedColor(template.button_color)
          setSelectedThemeColor(template.theme_color)
          setSelectedBGColor(template.button_bg_color)
          setFontFamily(template.font_family)
        } else {
          setSliderValue(parseInt(0))
          setSelectedColor(null)
          setSelectedThemeColor(null)
          setSelectedBGColor(null)
          setFontFamily(null)
        }
    }, [template])

    template = patchMediaURL( template, MEDIA_FIELDS )
    const onClickResetTheme = () => {
        if( window.confirm( 'Are you sure to reset this theme?'))
        {
            resetTheme(program.organization_id, program.id, template.id)
                .then( res => {
                    setTemplate({})
                })
        }
    }

    let formError = false;
    const modalAccentColor = selectedThemeColor || template?.theme_color || '#f97316';
    const modalAccentSoft = toRgba(modalAccentColor, 0.12, 'rgba(249, 115, 22, 0.12)');
    const modalAccentBorder = toRgba(modalAccentColor, 0.24, 'rgba(249, 115, 22, 0.24)');
    const modalAccentContrast = getContrastColor(modalAccentColor);
    const modalButtonBgColor = selectedBGColor || template?.button_bg_color || modalAccentColor;
    const modalButtonTextColor = selectedColor || template?.button_color || getContrastColor(modalButtonBgColor);
    const modalButtonRadius = `${Number.isFinite(sliderValue) ? sliderValue : 10}px`;
    const modalButtonStyle = {
        borderRadius: modalButtonRadius,
        color: modalButtonTextColor,
        backgroundColor: modalButtonBgColor,
        borderColor: modalButtonBgColor,
    };

    return (
    <Modal
        className={`modal-program manager-program-modal programTemplateModal modal-lg ${theme.className} ${rtl.direction}-support`}
        isOpen={isOpen}
        toggle={toggle}
        style={{
            '--manager-program-modal-accent': modalAccentColor,
            '--manager-program-modal-accent-soft': modalAccentSoft,
            '--manager-program-modal-accent-border': modalAccentBorder,
            '--manager-program-modal-accent-contrast': modalAccentContrast,
            '--manager-program-modal-button-bg': modalButtonBgColor,
            '--manager-program-modal-button-color': modalButtonTextColor,
            '--manager-program-modal-button-radius': modalButtonRadius,
        }}
    >
        <Form
            onSubmit={onSubmitForm}
            validate={validate}
            initialValues={template}
        >
        {({ handleSubmit, form, submitting, pristine, values }) => (
        <form className="form" onSubmit={handleSubmit}>
            <ModalHeader tag="div" className="manager-program-modal__header">
                <div className="manager-program-modal__header-row">
                    <div className="manager-program-modal__header-copy">
                        <h3 className="manager-program-modal__title">Theme Settings</h3>
                        <p className="manager-program-modal__subtitle">
                            Adjust branding, imagery, buttons, and typography for {program.name}.
                        </p>
                    </div>
                    <ButtonToolbar className="manager-program-modal__actions">
                        <Button outline color="primary" onClick={toggle}>Close</Button>
                        {formError = Object.keys(validate(values)).length > 0}
                    </ButtonToolbar>
                </div> 
            </ModalHeader>
            <ModalBody className="manager-program-modal__body">
                <Nav tabs className="manager-program-modal__tabs">
                  
                    <NavItem>
                        <NavLink
                          className={classnames({
                              active:
                                currentActiveTab === '1'
                          })}
                          onClick={() => { togglePan('1'); }}
                        >
                            General
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                          className={classnames({
                              active:
                                currentActiveTab === '2'
                          })}
                          onClick={() => { togglePan('2'); }}
                        >
                            Images
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                          className={classnames({
                              active:
                                currentActiveTab === '3'
                          })}
                          onClick={() => { togglePan('3'); }}
                        >
                            Buttons
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                          className={classnames({
                              active:
                                currentActiveTab === '4'
                          })}
                          onClick={() => { togglePan('4'); }}
                        >
                            Fonts
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={currentActiveTab} className="manager-program-modal__tab-panel">
                    <TabPane tabId="1">
                        <div className="form__form-group">
                            <span className="form__form-group-label thick">Theme Color</span>
                            <div className="form__form-group-field flex-column">
                                <ColorPicker
                                    name="theme_color"
                                    floatingLabelText={selectedThemeColor}
                                    value={selectedThemeColor}
                                    onChange={color =>{if (color) setSelectedThemeColor('#'+color.hex)}}
                                />
                            </div>
                        </div>
                        <p>&nbsp;</p>
                        <Row>
                            <Col xs="12" md="8" lg="8">
                                <div className="form__form-group">
                                    <span className="form__form-group-label thick">Welcome Message</span>
                                    <div className="form__form-group-field flex-column">
                                        <Field
                                          name="welcome_message"
                                          component={WYSIWYGEditor}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="8" lg="8">
                                <div className="form__form-group">
                                    <span className="form__form-group-label thick">Paricipant Homepage Message</span>
                                    <div className="form__form-group-field flex-column">
                                        <Field
                                          name="participant_homepage_message"
                                          component={WYSIWYGEditor}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <br/>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="manager-theme-settings__media-stack">
                            <section className="manager-theme-settings__media-section">
                                <div className="manager-theme-settings__media-head">
                                    <h4 className="manager-theme-settings__media-title">Brand Assets</h4>
                                    <p className="manager-theme-settings__media-description">
                                        Upload the primary logos and banner artwork used across the participant experience.
                                    </p>
                                </div>
                                <div className="manager-theme-settings__asset-grid">
                                    <ThemeMediaCard
                                        name="big_logo"
                                        title="Big Logo"
                                        description="Used in larger branded placements and landing views."
                                        required={true}
                                        currentTheme={currentTheme}
                                        src={template?.big_logo}
                                        previewClassName="manager-theme-settings__asset-preview--logo"
                                    />
                                    <ThemeMediaCard
                                        name="small_logo"
                                        title="Small Logo"
                                        description="Used in compact headers and navigation surfaces."
                                        required={true}
                                        currentTheme={currentTheme}
                                        src={template?.small_logo}
                                        previewClassName="manager-theme-settings__asset-preview--logo"
                                    />
                                    <ThemeMediaCard
                                        name="hero_banner"
                                        title="Hero Banner"
                                        description="Large format artwork for the homepage hero area."
                                        required={true}
                                        currentTheme={currentTheme}
                                        src={template?.hero_banner}
                                        cardClassName="manager-theme-settings__asset-card--hero"
                                        previewClassName="manager-theme-settings__asset-preview--banner"
                                    />
                                </div>
                            </section>
                            <section className="manager-theme-settings__media-section">
                                <div className="manager-theme-settings__media-head">
                                    <h4 className="manager-theme-settings__media-title">Slider Images</h4>
                                    <p className="manager-theme-settings__media-description">
                                        Curate the rotating homepage imagery. The first slide is required; additional slides are optional.
                                    </p>
                                </div>
                                <div className="manager-theme-settings__slider-grid">
                                    <ThemeMediaCard
                                        name="slider_01"
                                        title="Slide 1"
                                        description="Primary homepage slide."
                                        required={true}
                                        currentTheme={currentTheme}
                                        src={template?.slider_01}
                                        showDelete={isShowDeleteImage('slider_01')}
                                        onDelete={deleteImage}
                                        previewClassName="manager-theme-settings__asset-preview--slider"
                                    />
                                    <ThemeMediaCard
                                        name="slider_02"
                                        title="Slide 2"
                                        description="Optional supporting slide."
                                        currentTheme={currentTheme}
                                        src={template?.slider_02}
                                        showDelete={isShowDeleteImage('slider_02')}
                                        onDelete={deleteImage}
                                        previewClassName="manager-theme-settings__asset-preview--slider"
                                    />
                                    <ThemeMediaCard
                                        name="slider_03"
                                        title="Slide 3"
                                        description="Optional supporting slide."
                                        currentTheme={currentTheme}
                                        src={template?.slider_03}
                                        showDelete={isShowDeleteImage('slider_03')}
                                        onDelete={deleteImage}
                                        previewClassName="manager-theme-settings__asset-preview--slider"
                                    />
                                </div>
                            </section>
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <Row>
                            <Col sm="8">
                                <div className="form__form-group">
                                    <span className="form__form-group-label thick">Shape</span>
                                    <div>&nbsp;</div>
                                    <div className="form__form-group-field flex-column shape-slider">
                                    {currentTheme !== 'Default' && <Slider
                                          max={20}
                                          SliderConfig={SliderConfig}
                                          value={sliderValue}
                                          onChange={updateSliderRange}
                                          name='button_corner'
                                        />}
                                    </div>
                                </div>
                                <div className="form__form-group">
                                    <span className="form__form-group-label thick">Color</span>
                                    <div className="form__form-group-field flex-column">
                                        <ColorPicker
                                            name="color"
                                            floatingLabelText = {selectedColor}
                                            value={selectedColor}
                                            onChange={color =>{if (color) setSelectedColor('#'+color.hex)}}
                                        />
                                    </div>
                                </div>
                                <div className="form__form-group">
                                    <span className="form__form-group-label thick">Background Color</span>
                                    <div className="form__form-group-field flex-column">
                                        <ColorPicker
                                            name="background_color"
                                            floatingLabelText={selectedBGColor}
                                            value={selectedBGColor}
                                            onChange={color =>{if (color) updateBGColorHandler(color)}}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col sm="4" className='ml-2'>
                                <div className="button-result">
                                  <span className="form__form-group-label thick">Result</span>
                                  <br/>
                                  <br/>
                                    <Button
                                        style={modalButtonStyle}
                                        className="template-button"
                                        onClick={() => {return false;}}>
                                        My Button
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        <br/>
                    </TabPane>
                    <TabPane tabId="4">
                        <Row>
                            <Col sm="8">
                                <div className="form__form-group">
                                    <span className="form__form-group-label thick">Font Type</span><span className='error'>*</span>
                                    <div className="form__form-group-field flex-column">
                                        <Autocomplete
                                          className='custom_autocomplete'
                                          id="font_family"
                                          options={THEME_FONT_FAMILIES}
                                          sx={{width: 300}}
                                          onChange={fontFamilyHandler}
                                          value={fontFamily}
                                          renderInput={(params) => <TextField {...params}
                                            name='font_family' label="Choose Font" margin="normal"
                                          />}
                                        />
                                        {!fontFamily && <span className="form__form-group-error">Font family is required</span>}
                                    </div>
                                </div>
                            </Col>
                            <Col sm="4">
                            </Col>
                        </Row>
                        <br/>
                    </TabPane>
                </TabContent>
                <div className="manager-program-modal__footer-actions">
                    {(currentTheme && formError && !submitting && !loading) && (
                        <div className="manager-program-modal__footer-note">Required fields are missing.</div>
                    )}
                    <Button
                        type="submit"
                        disabled={submitting || formError || currentTheme === 'Default'}
                        className="btn btn-primary"
                        style={modalButtonStyle}
                        color="#ffffff"
                    >
                        Save Changes
                    </Button>
                </div>
            </ModalBody>
        </form>
        )}
        </Form>
    </Modal>
)}

const RenderImage = ({src, showDelete = false, name, dlcb, label }) => {
    if( !src || typeof src === 'undefined' ) {
      return (
        <div className="manager-theme-settings__asset-empty">
          <span className="manager-theme-settings__asset-empty-title">No image uploaded</span>
          <span className="manager-theme-settings__asset-empty-copy">{label} preview will appear here.</span>
        </div>
      )
    }
    return (
      <div className='dropzone-img position-relative'>
        <a href={src} target='_blank' rel="noreferrer" title='View the picture'>
          <img src={src} alt={label || 'Theme asset'} />
        </a>
        {(showDelete && dlcb) && (
          <button className="manager-theme-settings__asset-remove dropzone__img-delete" onClick={() => dlcb(name)} type="button">
            Remove
          </button>
        )}
      </div>
    )
}

ThemeSettings.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  organization: PropTypes.object,
  program: PropTypes.object
};

export default (connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization,
  program: state.program
}))(ThemeSettings));
